import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { DASHBOARD, PIM, DescriptionHash, UPDATE_PATIENT_HEADER_TO_PIM, UPDATE_PIM_PATIENT_DISCHARGE, MESSAGE_DASHBOARD_SAVE_MANIFEST_COMPLETE, MESSAGE_DASHBOARD_SAVE_MANIFEST_FAILED, MESSAGE_DASHBOARD_DOWNLOAD_COMPLETE, MESSAGE_DASHBOARD_PIM_LOCK_PATIENT, MESSAGE_DASHBOARD_PIM_UNLOCK_PATIENT, MESSAGE_DASHBOARD_PUT_SUCCESS, MESSAGE_PIM_DASHBOARD_PATIENT_SWITCH_REQUEST_PENDING } from './constants';

const logDocumentVisitPimMessage = (direction, messageId, payload) => {
  // eslint-disable-next-line no-console
  console.log(`[PIM document visit] ${direction}`, messageId, payload);
}; // Only post when embedded in PIM


const isEmbeddedInPim = () => typeof window !== 'undefined' && window.parent !== window; // For generating and posting to pim message bus


export const sendPimMessage = (type, messagePayload) => {
  const messageBodyToPim = _objectSpread({
    id: type,
    origin: DASHBOARD,
    destination: PIM,
    description: DescriptionHash[type] || ''
  }, messagePayload != null ? {
    payload: messagePayload
  } : {});

  if (type === MESSAGE_DASHBOARD_PIM_LOCK_PATIENT || type === MESSAGE_DASHBOARD_PIM_UNLOCK_PATIENT || type === MESSAGE_DASHBOARD_PUT_SUCCESS) {
    logDocumentVisitPimMessage('DASHBOARD → PIM', type, messageBodyToPim);
  }

  if (isEmbeddedInPim()) {
    window.parent.postMessage(messageBodyToPim, '*');
  }

  return messageBodyToPim;
};
export const updatePIMPatientHeader = () => sendPimMessage(UPDATE_PATIENT_HEADER_TO_PIM);
export const updatePIMBereavementList = () => {
  sendPimMessage(UPDATE_PIM_PATIENT_DISCHARGE);
};
export const updatePIMManifestSaveComplete = () => sendPimMessage(MESSAGE_DASHBOARD_SAVE_MANIFEST_COMPLETE);
export const updatePIMManifestSaveFailed = () => sendPimMessage(MESSAGE_DASHBOARD_SAVE_MANIFEST_FAILED);
export const notifyPIMDownloadIDGComplete = () => {
  sendPimMessage(MESSAGE_DASHBOARD_DOWNLOAD_COMPLETE);
};
export const lockPatientInPim = payload => sendPimMessage(MESSAGE_DASHBOARD_PIM_LOCK_PATIENT, payload);
export const unlockPatientInPim = payload => sendPimMessage(MESSAGE_DASHBOARD_PIM_UNLOCK_PATIENT, payload);
export const notifyPimVisitPutSuccess = payload => sendPimMessage(MESSAGE_DASHBOARD_PUT_SUCCESS, payload);

const validateMessage = event => {
  var _event$data;

  return typeof (event === null || event === void 0 ? void 0 : event.origin) === 'string' && (event === null || event === void 0 ? void 0 : event.origin.includes('.mumms.com')) && typeof (event === null || event === void 0 ? void 0 : event.data) !== 'string' && (event === null || event === void 0 ? void 0 : (_event$data = event.data) === null || _event$data === void 0 ? void 0 : _event$data.destination) === DASHBOARD;
};

export const initThemeListener = callback => {
  window.addEventListener('message', event => {
    const {
      data
    } = event;

    if (validateMessage(event) && data.id.includes('MESSAGE_PIM_DASHBOARD_UPDATED')) {
      const splitString = data.id.split('_');
      const themeType = splitString[splitString.length - 1].toLowerCase();
      setTimeout(function () {
        localStorage.setItem('mumms.theme', themeType);
        callback(themeType);
      }, 500);
    }
  });
};
export const initListener = dispatch => {
  window.addEventListener('message', event => {
    const {
      data
    } = event; // If the origin of the event is pim

    if (validateMessage(event)) {
      dispatch({
        type: data.id,
        payload: data
      });
    }
  });
};
/** PIM user chose another patient while document visit lock is active. */

export const initDocumentVisitSwitchListener = onPatientSwitchRequestPending => {
  const handler = event => {
    var _event$data2;

    if (!validateMessage(event)) {
      return;
    }

    if (((_event$data2 = event.data) === null || _event$data2 === void 0 ? void 0 : _event$data2.id) === MESSAGE_PIM_DASHBOARD_PATIENT_SWITCH_REQUEST_PENDING) {
      logDocumentVisitPimMessage('PIM → DASHBOARD', MESSAGE_PIM_DASHBOARD_PATIENT_SWITCH_REQUEST_PENDING, event.data);
      onPatientSwitchRequestPending();
    }
  };

  window.addEventListener('message', handler);
  return () => window.removeEventListener('message', handler);
};
/* 
  Copy and paste the command below to simulate message from PIM

  ! Attestation done from PIM 
  window.postMessage(
    {
      "id": "MESSAGE_PIM_DASHBOARD_IDG_ROLE_ATTESTATION_DONE",
      "origin": "PIM",
      "destination": "DASHBOARD",
      "description": "Refresh the IDG role attestation notes in IDG popup dashboard app",
      "messagePayload": {
          "roleId": "-3",
          "rolegroupName": "Doctor",
          "checked": "true",
          "agenda_start": "05/14/2022",
          "agenda_stop": "05/28/2022",
          "idgdiscussionStatus": "IN_PROGRESS",
          "physician_id": "-51",
          "physician_fname": "Physician",
          "physician_lname": "Apple",
          "physician_credentials": "MD"
      },
    },
    '*',
  );

  ! IDG review complete from PIM
  window.postMessage(
    {
      id: 'MESSAGE_PIM_DASHBOARD_IDG_ROLE_ATTESTATION_DONE',
      origin: 'PIM',
      destination: 'DASHBOARD',
      description:
        'Refresh the IDG role attestation notes in IDG popup dashboard app',
      messagePayload: {
        roleId: '',
        rolegroupName: 'Team Review and Acceptance',
        checked: 'true',
        agenda_start: '05/14/2022',
        agenda_stop: '05/28/2022',
        idgdiscussionStatus: 'COMPLETED',
        physician_id: '2',
        physician_fname: 'Eric',
        physician_lname: 'George',
        physician_credentials: '',
      },
    },
    '*',
  );

  ! Refresh the patient header from PIM
  window.postMessage(
    {
      id: 'MESSAGE_PIM_DASHBOARD_DEMOGRAPHICS_UPDATED',
      origin: 'PIM',
      destination: 'DASHBOARD',
      description: 'Refresh the patient header',
      messagePayload: {},
    },
    '*',
  );


   ! Refresh the patient header from PIM
  window.postMessage(
    {
      id: 'MESSAGE_PIM_DASHBOARD_UPDATED_BLUEBERRY',
      origin: 'PIM',
      destination: 'DASHBOARD',
      description: '',
      messagePayload: {},
    },
    '*',
  );

*/